import { render } from "./OpeningHoursModal.vue?vue&type=template&id=d698a8de"
import script from "./OpeningHoursModal.vue?vue&type=script&lang=js"
export * from "./OpeningHoursModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__